import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

export default defineNuxtPlugin((nuxtApp) => {
    
    
    
    const firebaseConfig = {
        apiKey: "AIzaSyCVB46AnkZ8IyfTNP8so26YWandngk2s4Q",
        authDomain: "sarpsborglegesenter.firebaseapp.com",
        projectId: "sarpsborglegesenter",
        storageBucket: "sarpsborglegesenter.firebasestorage.app",
        messagingSenderId: "655483334321",
        appId: "1:655483334321:web:61422729b7f8a25470fc90",

      };

    const app = initializeApp(firebaseConfig);
    const auth = getAuth(app);      
   

    nuxtApp.provide('auth', auth);
}); 